import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Badge, Button, Card, EmptyState, ErrorAlert } from '../components/ui';

type Any = Record<string, any>;

export function NieboGuardBulletinsSection() {
  const [items, setItems] = useState<Any[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [notice, setNotice] = useState<string | null>(null);

  const load = useCallback(async () => {
    setItems((await api.nieboguard.bulletins.list()).bulletins);
  }, []);
  useEffect(() => { load().catch(setError); }, [load]);

  const run = async (key: string, fn: () => Promise<unknown>, message: string) => {
    setBusy(key); setError(null); setNotice(null);
    try { await fn(); setNotice(message); await load(); }
    catch (err) { setError(err); }
    finally { setBusy(null); }
  };

  return (
    <>
      {error ? <ErrorAlert error={error} /> : null}
      {notice ? <Card><div className="nb-stat-note">{notice}</div></Card> : null}
      <Card title="Biuletyny NG TV" actions={<Button size="sm" variant="primary" disabled={busy === 'generate'} onClick={() => run('generate', () => api.nieboguard.bulletins.generate(), 'Biuletyn wygenerowany z bieżących zweryfikowanych zdarzeń.')}>Generuj z zdarzeń</Button>}>
        <p className="nb-stat-note">Biuletyn jest deterministyczny: powstaje wyłącznie z aktywnych zdarzeń OFFICIAL/CORROBORATED. Brak materiału oznacza brak biuletynu, nie wymyślanie treści.</p>
        <div className="nb-list">
          {items.map((item) => (
            <div className="nb-item" key={item.id}>
              <div className="nb-row nb-row--between">
                <div>
                  <div className="nb-item__title">{item.title}</div>
                  <div className="nb-item__meta"><Badge tone={item.status === 'APPROVED' ? 'success' : item.status === 'REJECTED' ? 'danger' : 'warning'}>{item.status}</Badge><span>P{item.priority}</span><span>{item.language}</span><span>{item.createdAt}</span></div>
                </div>
                <div className="btn-row">
                  <Button size="sm" variant="primary" disabled={item.status === 'APPROVED' || busy === `approve-${item.id}`} onClick={() => run(`approve-${item.id}`, () => api.nieboguard.bulletins.approve(item.id), 'Biuletyn zatwierdzony.')}>Zatwierdź</Button>
                  <Button size="sm" variant="ghost" disabled={busy === `reject-${item.id}`} onClick={() => run(`reject-${item.id}`, () => api.nieboguard.bulletins.reject(item.id), 'Biuletyn odrzucony.')}>Odrzuć</Button>
                </div>
              </div>
              <pre className="nb-code" style={{ whiteSpace: 'pre-wrap', marginTop: 10 }}>{item.body}</pre>
            </div>
          ))}
          {items.length === 0 ? <EmptyState title="Brak biuletynów" hint="Wygeneruj biuletyn z bieżących, zweryfikowanych zdarzeń." /> : null}
        </div>
      </Card>
    </>
  );
}
